import { useState, useEffect, useCallback } from 'react';
import DataTable from 'react-data-table-component';
import db from '../../db/db';

const Gastos = () => {
    const [gastos, setGastos] = useState([]);
    const [proveedores, setProveedores] = useState([]);
    const [metodos, setMetodos] = useState([]);

    const cargarGastos = useCallback(async () => {
        const sesion = await db.sesion.toArray();
        const sucursalId = sesion[0]?.sucursal?._id || sesion[0]?.sucursal;
        const [gs, provs, mets] = await Promise.all([
            db.gastos.filter(g => String(g.sucursal?._id || g.sucursal) === String(sucursalId)).toArray(),
            db.proveedores.toArray(),
            db.metodos.toArray(),
        ]);
        setProveedores(provs);
        setMetodos(mets);
        setGastos(gs.sort((a, b) => new Date(b.fecha) - new Date(a.fecha)));
    }, []);

    useEffect(() => { cargarGastos(); }, [cargarGastos]);

    const resolver = (id, lista) => {
        if (!id) return '—';
        const item = lista.find(x => x._id === id || String(x.id) === String(id));
        return item?.nombre || '—';
    };

    const columns = [
        {
            name: 'Fecha',
            selector: row => row.fecha,
            sortable: true,
            grow: 1,
            cell: row => {
                const d = new Date(row.fecha);
                return (
                    <span style={{ color: '#C0C0C0', fontSize: '0.85rem' }}>
                        {d.toLocaleDateString('es-MX')} {d.toLocaleTimeString('es-MX', { hour: '2-digit', minute: '2-digit' })}
                    </span>
                );
            },
        },
        {
            name: 'Total',
            selector: row => row.total,
            sortable: true,
            grow: 0.5,
            cell: row => (
                <span style={{ color: '#F0F0F0', fontWeight: 700 }}>
                    ${(row.total || 0).toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                </span>
            ),
        },
        {
            name: 'Proveedor',
            selector: row => resolver(row.proveedor, proveedores),
            sortable: true,
            grow: 1,
            cell: row => <span style={{ color: '#C0C0C0' }}>{resolver(row.proveedor, proveedores)}</span>,
        },
        {
            name: 'Método',
            selector: row => resolver(row.metodo, metodos),
            sortable: true,
            grow: 1,
            cell: row => <span style={{ color: '#C0C0C0' }}>{resolver(row.metodo, metodos)}</span>,
        },
        {
            name: 'Concepto',
            selector: row => row.concepto,
            sortable: true,
            grow: 3,
            cell: row => (
                <span style={{ color: '#C0C0C0', whiteSpace: 'normal', paddingTop: '0.4rem', paddingBottom: '0.4rem' }}>
                    {row.concepto || '—'}
                </span>
            ),
        },
    ];

    return (
        <div style={styles.page}>
            <div style={styles.header}>
                <i className="fas fa-file-invoice-dollar me-3" style={{ color: '#F5C800', fontSize: '1.3rem' }}></i>
                <h4 style={styles.titulo}>Historial de gastos</h4>
            </div>

            <div style={styles.tableWrap}>
                <DataTable
                    columns={columns}
                    data={gastos}
                    pagination
                    paginationPerPage={15}
                    paginationRowsPerPageOptions={[10, 15, 25, 50]}
                    noDataComponent={
                        <div style={styles.vacio}>
                            <i className="fas fa-file-invoice-dollar" style={{ fontSize: '2rem', color: '#333', marginBottom: '0.75rem' }}></i>
                            <p style={{ color: '#888', margin: 0 }}>No hay gastos registrados</p>
                        </div>
                    }
                    customStyles={tableStyles}
                    defaultSortFieldId={1}
                    defaultSortAsc={false}
                    dense
                />
            </div>
        </div>
    );
};

const styles = {
    page: {
        maxWidth: '1400px',
        margin: '0 auto',
    },
    header: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: '1.5rem',
        paddingBottom: '1rem',
        borderBottom: '1px solid #2E2E2E',
    },
    titulo: {
        color: '#F0F0F0',
        fontWeight: 700,
        margin: 0,
    },
    tableWrap: {
        background: '#1A1A1A',
        border: '1px solid #2E2E2E',
        borderRadius: '14px',
        overflow: 'hidden',
    },
    vacio: {
        padding: '3rem',
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
};

const tableStyles = {
    table: { style: { background: '#1A1A1A' } },
    headRow: { style: { background: '#111111', borderBottomColor: '#2E2E2E' } },
    headCells: { style: { color: '#888888', fontSize: '0.8rem', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.5px' } },
    rows: { style: { background: '#1A1A1A', borderBottomColor: '#222222', minHeight: '52px', '&:hover': { background: '#1F1F1F' } } },
    pagination: { style: { background: '#111111', borderTopColor: '#2E2E2E', color: '#888' } },
    noData: { style: { background: '#1A1A1A' } },
};

export default Gastos;
